export default __webpack_public_path__ + "assets/1390a26ec41289594d9cc8ed9972982a.svg";